import { render, staticRenderFns } from "./GeneralAgentFormAdditional.vue?vue&type=template&id=08718ee7&scoped=true&"
import script from "./GeneralAgentFormAdditional.vue?vue&type=script&lang=ts&"
export * from "./GeneralAgentFormAdditional.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralAgentFormAdditional.vue?vue&type=style&index=0&id=08718ee7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08718ee7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
